<template>
  <div class="container container-fixed-lg p-t-20 p-b-20">
    <h1 class="page-title">Titre de la page en cours</h1>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue